import Button from '@zuto/atoms/src/Mui/Button/Button'

const CenteredButton = Button

export default CenteredButton
